<template>
  <div>
    <el-container class="el-container-height">
      <el-header>
        <share/>
      </el-header>
      <el-main >
        <div class="left-nav"  >
          <div class="left-nav-content" style="position: relative;width:100%;height:100%;" >
            <router-link class="item" :to="item.url+id" v-for="(item,index) in navList" :key="index">
              <div class="item-icon"><svg-icon :iconClass="item.icon" /></div>
              <div class="item-name">{{item.title}}</div>
            </router-link>
          </div>
        </div>
        <router-view/>
      </el-main>
    </el-container>
    <!--<div class="footer">@光问卷</div>-->
  </div>
</template>
<script>
import Share from './share';

export default {
  name: 'qms',
  components:{
    Share
  },
  data () {
    return {
      index:0,
      title:'题型',
      navList:[
        {icon:'tixing',title:'题型',url:'/edit/'},
        {icon:'theme',title:'主题',url:'/edit/theme/'},
        {icon:'luoji',title:'逻辑',url:'/edit/logic/'},
        {icon:'peizhi',title:'配额',url:'/edit/quota/'},
        {icon:'cascade',title:'级联',url:'/edit/template/'},
        // {icon:'storeNum',title:'样本控制',url:'/edit/storeNum/'},
        {icon:'biaoqian',title:'预览',url:'/edit/visit/'},
        // {icon:'biaoqian',title:'标签',url:'/edit/label/'},
      ],
      id:'',
      titleList: [
        {
          title: '我的问卷',
          url: '/'
        },
        {
          title: '问卷类型'
        }
      ],
      showLeft:false
    }
  },
  methods: {
    showLeftNav(){
      this.showLeft = true;
    },
    /* navIndex(item){
       this.title = item.title
       let id = this.$route.params.id;
       this.$router.push({path:item.url+id})
     },*/
    toUrl (url) {
      this.$router.push(url)
    }
  },
  created () {
    this.id = this.$route.params.id;
  }
}
</script>

<style lang="scss" scoped>
.el-main {
  width: calc(100% - 70px);
  margin-left: 70px;
}
.el-container-height{height:100vh;.el-header{background:#ffffff;}}
.router-link-active{
  .item-icon{
    background: #3d9cfe;
    .svg-icon{
      fill:#ffffff !important;
    }
  }
  .item-name{
    color:#3d9cfe !important;
  }
}
.left-nav{
  position: fixed;
  left:0;
  top:60px;
  z-index: 999;
  width: 70px;
  background: rgba(255,255,255,0);
  backdrop-filter: saturate(180%) blur(6px);
  height: calc(100% - 60px);
  box-shadow: 0 10px 10px rgba(0,0,0,0.1);
  .left-nav-content{
    padding:10px;
    box-sizing: border-box;
    .item{
      .item-icon{
        width:100%;
        height:50px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        .svg-icon{
          width:30px;
          height:30px;
          fill:#484848;
        }
      }
      .item-name{
        font-size: 12.5px;
        text-align: center;
        color:#484848;
        line-height: 24px;
      }
    }
    .open{
      position: absolute;
      top:0;
      right:-8px;
      bottom:0;
      width:8px;
      height:200px;
      background:#ccc;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      margin:auto;
      cursor: pointer;
    }
  }
}
.img{height:60px;width: 150px;position: absolute;left:20px;display: flex;align-items: center;}
.logo{width:150px;}
.footer{height:60px;line-height: 60px;text-align: center;color:#333;}
input:-webkit-autofill {-webkit-box-shadow: 0 0 0 1000px #fff inset;}
.login-container .el-input input:-webkit-autofill{-webkit-box-shadow: 0 0 0 1000px #fff inset !important;}
</style>



// WEBPACK FOOTER //
// src/views/layout/qms.vue